import PropTypes from 'prop-types';
import { useContext, useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import fromVms from '../../../utils/fromVms';
import { VideoPlayerScripts } from '../VideoPlayer/VideoPlayerScripts';
import AppContext from '../../../context/AppContext';

const VideoPlayer = dynamic(
	() => import('../VideoPlayer/VideoPlayer'),
	{ ssr: false },
);
function VmsVideo(props) {
	const {
		id, fallback = null, items = [], loading = false, errorState = false, customConfig = {},
		onVideoLoaded = () => {}, loadScripts = true, placeHolder = null, disableAd = false,
	} = props;

	const { adTargeting } = useContext(AppContext);

	let video;

	if (items.length < 1) {
		// Placeholder properties to allow video player to continue construction.
		video = {
			data: {},
			resources: [],
		};
	} else {
		[video] = items;
	}

	const [isVideoLoaded, setIsVideoLoaded] = useState(false);

	useEffect(() => {
		if (isVideoLoaded) {
			onVideoLoaded();
		}
	}, [isVideoLoaded, onVideoLoaded]);

	const handleVideoLoaded = () => {
		if (!isVideoLoaded) {
			setIsVideoLoaded(true);
		}
	};

	const handlePlayerReady = (playerInstance) => {
		const { onPlayerReady } = props;
		if (typeof onPlayerReady === 'function') {
			onPlayerReady(playerInstance);
		}
	};

	return (
		<>
			{(!errorState) ? (
				<div className="article-video">
					{ loadScripts && <VideoPlayerScripts /> }
					{ !loading
						? (
							<VideoPlayer
								videoId={id}
								fullscreenMode={false}
								adTargeting={adTargeting}
								customConfig={customConfig}
								onVideoLoaded={handleVideoLoaded}
								onPlayerReady={handlePlayerReady}
								placeHolder={placeHolder}
								disableAd={disableAd}
								// eslint-disable-next-line react/jsx-props-no-spreading
								{...video}
							/>
						) : null }
				</div>
			)
				: fallback }
		</>
	);
}

VmsVideo.propTypes = {
	id: PropTypes.string.isRequired,
	customConfig: PropTypes.shape({
		autostart: PropTypes.bool,
		autoplay: PropTypes.bool,
		mute: PropTypes.bool,
		divId: PropTypes.number,
		stretching: PropTypes.string,
		mutedAutoplay: PropTypes.bool,
	}),
	items: PropTypes.array,
	disableAd: PropTypes.bool,
	loading: PropTypes.bool,
	errorState: PropTypes.oneOfType([
		PropTypes.object,
		PropTypes.bool,
	]),
	fallback: PropTypes.element,
};

const propMapping = (props) => ({
	guid: props.id,
});

export default fromVms(VmsVideo, propMapping);
